/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from 'react';
import './more-menu.css';
import { MORE_MENU_SCREEN, COMMON, API_CONSTANTS, SYNC_SERVICE, ALL_ROUTES } from '../../global/Constants';
import { withRouter } from 'react-router-dom';
import Select from 'react-select';
import { toast } from 'react-toastify';
import moment from 'moment';
import ApiServices from '../../providers/ApiServices';
import Utilities from '../../global/Utilities';
import SyncServices from '../../providers/SyncServices';

import $ from 'jquery';
import DataProvider from '../../providers/DataProvider';
import { CROP_GROUP } from '../../global/Enum';


const otpTimer = 60;
class RetailerRegistrationPage extends Component {

    constructor(props) {
        super(props);

        this.state = {
            shopName: "",
            mobile: "",
            retailerName: "",
            dob: "",
            address: "",
            pinCode: "",
            email: "",
            latitude: null,
            longitude: null,

            selectedState: null,
            selectedDistrict: null,
            selectedTehsil: null,
            selectedVillage: null,
            allStatesData: [],
            allDistrictsData: [],
            allTehsilsData: [],
            allVillagesData: [],

            digit1: "",
            digit2: "",
            digit3: "",
            digit4: "",

            otpMatch: false,
            time: {},
            seconds: otpTimer,
        }
        this.timer = 0;
        this.startTimer = this.startTimer.bind(this);
        this.countDown = this.countDown.bind(this);
    }

    async componentDidMount() {
        if (localStorage.getItem(API_CONSTANTS.ACCESS_TOKEN) !== null) {
            document.getElementById("continue").disabled = true;
            toast.configure();
            this.getAllStates();
            this.getUserLocation();
            //this.assignedGroup();
        } else {
            this.props.history.replace(ALL_ROUTES.SIGN_IN_ROUTE);
        }

    }

    assignedGroup = () => {
        let is_vc = [];
        if (this.checkVegCrops(CROP_GROUP.FIELD_CROPS)) {
            is_vc.push(0);
        }

        if (this.checkVegCrops(CROP_GROUP.VEGETABLE_CROPS)) {
            is_vc.push(1);
        }
        return is_vc;
    }

    checkVegCrops = (cropGroupId) => {
        const cropGroups = DataProvider.getInstance().getCropGroups();
        //Utilities.LogPrint("CropGroups", cropGroups);
        if (cropGroups.length > 0) {
            //Utilities.LogPrint("CropGroups In Menu", cropGroups?.some(item => item.crop_group_id === CROP_GROUP.VEGETABLE_CROPS));
            return cropGroups?.some(item => item.crop_group_id === cropGroupId);
        } else {
            return false;
        }
    }

    componentWillUnmount() {
        clearInterval(this.timer);
    }

    getUserLocation = async () => {
        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(position => {
                const coords = position.coords;

                this.setState({
                    latitude: coords.latitude.toFixed(6),
                    longitude: coords.longitude.toFixed(6)
                });
            }, (error) => {
                Utilities.LogPrint("Error Code = " + error.code + " - " + error.message);
            });
        }
    }

    startTimer() {
        if (this.timer === 0 && this.state.seconds > 0) {
            this.timer = setInterval(this.countDown, 1000);
            Utilities.LogPrint("timer Main", this.timer);
        }
        let timeLeftVar = Utilities.secondsToTime(this.state.seconds);
        this.setState({ time: timeLeftVar });
    }

    countDown() {
        // Remove one second, set state so a re-render happens.
        let seconds = this.state.seconds - 1;

        if (seconds >= 0) {
            this.setState({
                time: Utilities.secondsToTime(seconds),
                seconds: seconds,
            });
        }

        // Check if we're at zero.
        if (seconds === 0) {
            clearInterval(this.timer);
        }
    }



    handleGenerateOTP = (e) => {
        if (!Utilities.isNetworkConnected()) {
            toast.info(COMMON.NO_INTERNET_CONNECTION);
            return;
        }

        //document.getElementById("otp").setAttribute('data-target', '#generateOtp');
        this.sentRetailerOtp();
    }


    sentRetailerOtp = () => {
        const { mobile } = this.state;
        if (!Utilities.isNetworkConnected()) {
            toast.info(COMMON.NO_INTERNET_CONNECTION);
            return;
        }

        var request = JSON.stringify({
            phone: mobile
        });
        this.props.loaderCallback(true);
        try {
            ApiServices.sentRetailerOtp(request)
                .then(response => {
                    Utilities.LogPrint("sentRetailerOtp: ---->", response);
                    this.props.loaderCallback(false);
                    if (response.success) {
                        toast.info(response.message);
                        this.startTimer();
                        $('#otpButton').trigger('click');
                        //const data = response.data;

                    } else {
                        toast.info(response.message);
                        Utilities.LogPrint("Status", response.message);
                    }
                }).catch(error => {
                    this.props.loaderCallback(false);
                    Utilities.LogPrint("sentRetailerOtp", error);
                });
        } catch (error) {
            this.props.loaderCallback(false);
            Utilities.LogPrint("sentRetailerOtp", error);
        }
    }

    verifyRetailerOtp = () => {
        if (!Utilities.isNetworkConnected()) {
            toast.info(COMMON.NO_INTERNET_CONNECTION);
            return;
        }

        const { mobile, digit1, digit2, digit3, digit4 } = this.state;
        const otpNumber = digit1 + digit2 + digit3 + digit4;
        var request = JSON.stringify({
            phone: mobile,
            otp: otpNumber
        });
        this.props.loaderCallback(true);
        try {
            ApiServices.verifyRetailerOtp(request)
                .then(response => {
                    Utilities.LogPrint("verifyRetailerOtp: ---->", response);
                    this.props.loaderCallback(false);
                    clearInterval(this.timer);
                    if (response.success) {
                        this.addRetailer();
                        //const data = response.data;
                    } else {
                        //toast.info(response.message);
                        Utilities.LogPrint("Status", response.message);
                        $('#otpFailed').trigger('click');

                    }
                }).catch(error => {
                    this.props.loaderCallback(false);
                    Utilities.LogPrint("verifyRetailerOtp", error);
                });
        } catch (error) {
            this.props.loaderCallback(false);
            Utilities.LogPrint("verifyRetailerOtp", error);
        }
    }

    resetData = () => {
        this.setState({
            shopName: "",
            mobile: "",
            retailerName: "",
            dob: "",
            address: "",
            selectedState: null,
            selectedDistrict: null,
            selectedTehsil: null,
            selectedVillage: null,
            pinCode: "",
            email: "",
            // Reset OTP Inputs
            digit1: "",
            digit2: "",
            digit3: "",
            digit4: "",
            seconds: otpTimer

        });
    }

    addRetailer = () => {
        const { shopName, mobile, retailerName, dob, address, selectedState, selectedDistrict, selectedTehsil, selectedVillage,
            pinCode, email, latitude, longitude } = this.state;

        let request = JSON.stringify({
            retailer_shop_name: shopName,
            phone: mobile,
            retailer_name: retailerName,
            dob: dob,
            address: address,
            state_id: selectedState.value,
            district_id: selectedDistrict.value,
            tehsil_id: selectedTehsil.value,
            village_id: selectedVillage.value,
            pin_code: pinCode,
            retailer_email: email,
            latitude: latitude,
            longitude: longitude,
            is_vc: this.assignedGroup()
        });

        Utilities.LogPrint("Request", request);
        this.props.loaderCallback(true);
        try {
            ApiServices.addRetailer(request)
                .then(response => {
                    Utilities.LogPrint("addRetailer: ---->", response);
                    this.props.loaderCallback(false);
                    if (response.success) {
                        //const data = response.data;
                        $('#otpSuccess').trigger('click');
                        this.resetData();

                    } else {
                        toast.info(response.message);
                        Utilities.LogPrint("Status", response.message);
                    }
                }).catch(error => {
                    this.props.loaderCallback(false);
                    Utilities.LogPrint("addRetailer", error);
                });
        } catch (error) {
            this.props.loaderCallback(false);
            Utilities.LogPrint("addRetailer", error);
        }
    }

    handleResendOTP = (e) => {
        this.timer = 0;
        this.setState({
            digit1: "",
            digit2: "",
            digit3: "",
            digit4: "",
            seconds: otpTimer
        }, () => {
            //this.startTimer();
            this.sentRetailerOtp();
        });
    }


    getAllStates = () => {
        SyncServices.getDataFromDatabase(SYNC_SERVICE.ACTION_STATE, SYNC_SERVICE.MASTER_TABLE).then(data => {
            //Utilities.LogPrint("allStatesData", data);
            if (data && data !== undefined && data.length > 0) {
                this.setState({
                    allStatesData: data.map(({ state_id: value, state_name: label, ...rest }) => ({ value, label, ...rest }))
                });
            }
        });
    }

    getAllDistricts = (selectedState) => {
        // SyncServices.getDataFromDatabase(SYNC_SERVICE.ACTION_DISTRICT, SYNC_SERVICE.MASTER_TABLE).then(data => {
        //     if (data && data !== undefined && data.length > 0) {
        //         var filterData = [];
        //         for (var i = 0; i < data.length; i++) {
        //             if (data[i].state_id === selectedState.value) {
        //                 filterData.push(data[i]);
        //             }
        //         }
        //         this.setState({
        //             allDistrictsData: filterData.map(({ district_id: value, district_name: label, ...rest }) => ({ value, label, ...rest }))
        //         });
        //     }
        // });

        const request = JSON.stringify({
            page: 1,
            perPage: 10000,
            sortBy: "district_name",
            sortOrder: "ASC",
            state_id: selectedState?.value,
        })

        try {
            ApiServices.getAllDistrictByReferenceId(request)
                .then(response => {
                    Utilities.LogPrint("getAllTehsilByReferenceId: ---->", response);
                    if (response.success) {
                        const data = response?.data;

                        if (data) {
                            this.setState({
                                allDistrictsData: data?.map(({ district_id: value, district_name: label, ...rest }) => ({ value, label, ...rest }))
                            });
                        }
                    } else {
                        Utilities.LogPrint("Status", response.message);
                    }
                }).catch(error => {
                    Utilities.LogPrint("getAllTehsilByReferenceId", error);
                });
        } catch (error) {
            Utilities.LogPrint("getAllTehsilByReferenceId", error);
        }
    }

    getAllTehsils = (selectedDistrict) => {
        const { selectedState } = this.state;
        // SyncServices.getDataFromDatabase(SYNC_SERVICE.ACTION_TEHSIL, SYNC_SERVICE.MASTER_TABLE).then(data => {
        //     if (data && data !== undefined && data.length > 0) {
        //         var filterData = [];
        //         for (var i = 0; i < data.length; i++) {
        //             if (data[i].district_id === selectedDistrict.value) {
        //                 filterData.push(data[i]);
        //             }
        //         }

        //         this.setState({
        //             allTehsilsData: filterData.map(({ tehsil_id: value, tehsil_name: label, ...rest }) => ({ value, label, ...rest }))
        //         });
        //     }
        // });

        const request = JSON.stringify({
            page: 1,
            perPage: 10000,
            sortBy: "tehsil_name",
            sortOrder: "ASC",
            state_id: selectedState?.value,
            district_id: selectedDistrict?.value
        })

        try {
            ApiServices.getAllTehsilByReferenceId(request)
                .then(response => {
                    Utilities.LogPrint("getAllTehsilByReferenceId: ---->", response);
                    if (response.success) {
                        const data = response?.data?.data;

                        if (data) {
                            this.setState({
                                allTehsilsData: data?.map(({ tehsil_id: value, tehsil_name: label, ...rest }) => ({ value, label, ...rest }))
                            });
                        }
                    } else {
                        Utilities.LogPrint("Status", response.message);
                    }
                }).catch(error => {
                    Utilities.LogPrint("getAllTehsilByReferenceId", error);
                });
        } catch (error) {
            Utilities.LogPrint("getAllTehsilByReferenceId", error);
        }
    }

    getAllVillageById = (selectedTehsil) => {
        const { selectedState, selectedDistrict } = this.state;
        // SyncServices.getDataFromDatabase(SYNC_SERVICE.ACTION_VILLAGE, SYNC_SERVICE.MASTER_TABLE).then(data => {
        //     if (data && data !== undefined && data.length > 0) {
        //         var filterData = [];

        //         for (var i = 0; i < data.length; i++) {
        //             if (data[i].tehsil_id === selectedTehsil.value) {
        //                 filterData.push(data[i]);
        //             }
        //         }
        //         this.setState({
        //             allVillagesData: filterData.map(({ village_id: value, village_name: label, ...rest }) => ({ value, label, ...rest }))
        //         });
        //     }
        // });


        const request = JSON.stringify({
            page: 1,
            perPage: 10000,
            sortBy: "village_name",
            sortOrder: "ASC",
            state_id: selectedState?.value,
            district_id: selectedDistrict?.value,
            tehsil_id: selectedTehsil?.value
        });

        try {
            ApiServices.getAllVillageById(request)
                .then(response => {
                    Utilities.LogPrint("getAllVillageById: ---->", response);
                    if (response.success) {
                        const data = response?.data;

                        if (data) {
                            this.setState({
                                allVillagesData: data?.map(({ village_id: value, village_name: label, ...rest }) => ({ value, label, ...rest }))
                            });
                        }
                    } else {
                        Utilities.LogPrint("Status", response.message);
                    }
                }).catch(error => {
                    Utilities.LogPrint("getAllVillageById", error);
                });
        } catch (error) {
            Utilities.LogPrint("getAllVillageById", error);
        }


    }

    handleStateChange = selectedState => {
        if (selectedState === null) {
            this.setState({
                selectedState: null,
                selectedDistrict: null,
                selectedTehsil: null,
                selectedVillage: null,
            });
        } else {
            this.setState({
                selectedState, selectedDistrict: null,
                selectedTehsil: null,
                selectedVillage: null, allDistrictsData: [], allTehsilsData: [], allVillagesData: []
            });
            this.getAllDistricts(selectedState);
        }
    };

    handleDistrictChange = selectedDistrict => {
        if (selectedDistrict === null) {
            this.setState({
                selectedDistrict: null,
                selectedTehsil: null,
                selectedVillage: null,
            });
        } else {
            this.setState({
                selectedDistrict, selectedTehsil: null,
                selectedVillage: null, allTehsilsData: [], allVillagesData: []
            });
            this.getAllTehsils(selectedDistrict);
        }
    };

    handleTehsilChange = selectedTehsil => {
        if (selectedTehsil === null) {
            this.setState({
                selectedTehsil: null,
                selectedVillage: null,
            }, () => {

            });
        } else {
            this.setState({ selectedTehsil, selectedVillage: null, allVillagesData: [] }, () => {

            });
            this.getAllVillageById(selectedTehsil);
        }
    };

    handleVillageChange = selectedVillage => {
        this.setState({ selectedVillage });
    };

    changeHandler = (e) => {
        this.setState({ [e.target.name]: e.target.value });
    }

    handleOTPChange(e, ref) {
        const { digit1, digit2, digit3, digit4 } = this.state;
        e.preventDefault();
        this.setState({ [e.target.name]: e.target.value });

        if (digit1 === "" || digit2 === "" || digit3 === "" || digit4 !== "") {
            document.getElementById("continue").disabled = true;
        } else {
            document.getElementById("continue").disabled = false;
        }

        if (ref !== this.myInp1) {
            ref.focus();
        }
    }

    isFormValid() {
        const { shopName, mobile, retailerName, selectedState, selectedDistrict, selectedTehsil } = this.state;
        return shopName.length === 0 || mobile.length === 0 || retailerName.length === 0 ||
            selectedState === null || selectedDistrict === null || selectedTehsil === null;
    }

    render() {

        const { isActive } = this.props;
        const { shopName, mobile, retailerName, dob, address,
            allStatesData, allDistrictsData, allTehsilsData, allVillagesData,
            selectedState, selectedDistrict, selectedTehsil, selectedVillage,
            pinCode, email } = this.state;

        return (
            <div id="myProfile" className={isActive ? "more-menu-body" : "more-menu-body d-none"}>
                <form>
                    <div className="row">
                        <div className="col-12">
                            <h6 className="mb-3">
                                <a className="more-menu-back" onClick={() => { this.props._sendToParent(false) }}>
                                    <i className="customic ic-back-button"></i>
                                </a>
                                {MORE_MENU_SCREEN.RETAILER_REGISTRATION}
                            </h6>
                        </div>
                    </div>


                    <div className="row">
                        <div className="col-12 col-md-6">
                            <div className="form-group">
                                <label className="font-weight-medium">Shop Name*</label>
                                <input type="text" className="form-control" name="shopName" placeholder="Enter Name" onChange={this.changeHandler} value={shopName} />
                            </div>
                        </div>
                        <div className="col-12 col-md-6">
                            <div className="form-group">
                                <label className="font-weight-medium">Mobile Number*</label>
                                <input type="text" className="form-control" name="mobile" maxLength="10" placeholder="Enter Mobile Number" onChange={this.changeHandler} value={mobile} />
                            </div>
                        </div>
                        <div className="col-12 col-md-6">
                            <div className="form-group">
                                <label className="font-weight-medium">Retailer Name*</label>
                                <input type="text" className="form-control" name="retailerName" placeholder="Enter Retailer Name" onChange={this.changeHandler} value={retailerName} />
                            </div>
                        </div>
                        <div className="col-12 col-md-6">
                            <div className="form-group">
                                <label className="font-weight-medium">Date of Birth</label>
                                <div className="form-group input-date">
                                    <input type="date"
                                        className="form-control"
                                        name="dob"
                                        value={dob}
                                        onChange={this.changeHandler}
                                        min={moment().subtract(74, 'years').format("YYYY-MM-DD")}
                                        max={moment().subtract(1, 'days').format("YYYY-MM-DD")} />
                                </div>
                            </div>
                        </div>
                        <div className="col-12 col-md-12">
                            <div className="form-group">
                                <label className="font-weight-medium">Address</label>
                                <input type="text"
                                    className="form-control"
                                    name="address"
                                    value={address}
                                    placeholder="Enter Address"
                                    onChange={this.changeHandler} />
                            </div>
                        </div>

                        <div className="col-12 col-md-6">
                            <div className="form-group">
                                <label className="font-weight-medium">State*</label>
                                <Select className="mb-3 max-w-360"
                                    value={selectedState}
                                    onChange={this.handleStateChange}
                                    options={allStatesData}
                                    placeholder="Select State"
                                    isClearable={true} />
                            </div>
                        </div>

                        <div className="col-12 col-md-6">
                            <div className="form-group">
                                <label className="font-weight-medium">District*</label>
                                <Select className="mb-3 max-w-360"
                                    value={selectedDistrict}
                                    onChange={this.handleDistrictChange}
                                    options={allDistrictsData}
                                    placeholder="Select District"
                                    isClearable={true}
                                    isDisabled={selectedState === null ? true : false}
                                />
                            </div>
                        </div>

                        <div className="col-12 col-md-6">
                            <div className="form-group">
                                <label className="font-weight-medium">Tehsil*</label>
                                <Select className="mb-3 max-w-360"
                                    value={selectedTehsil}
                                    onChange={this.handleTehsilChange}
                                    options={allTehsilsData}
                                    placeholder="Select Tehsil"
                                    isClearable={true}
                                    isDisabled={selectedDistrict === null ? true : false}
                                />
                            </div>
                        </div>

                        <div className="col-12 col-md-6">
                            <div className="form-group">
                                <label className="font-weight-medium">Village</label>
                                <Select className="mb-3 max-w-360"
                                    value={selectedVillage}
                                    onChange={this.handleVillageChange}
                                    options={allVillagesData}
                                    placeholder="Select Village"
                                    isClearable={true}
                                    isDisabled={selectedTehsil === null ? true : false}
                                />
                            </div>
                        </div>

                        <div className="col-12 col-md-6">
                            <div className="form-group">
                                <label className="font-weight-medium">Pin code</label>
                                <input type="text" className="form-control" name="pinCode" value={pinCode} maxLength="6" placeholder="Enter Pin Code" onChange={this.changeHandler} />
                            </div>
                        </div>

                        <div className="col-12 col-md-6">
                            <div className="form-group">
                                <label className="font-weight-medium">Email ID</label>
                                <input type="text" className="form-control" name="email" value={email} placeholder="Enter Email ID" onChange={this.changeHandler} />
                            </div>
                        </div>

                    </div>

                    <div className="row">
                        <div className="col-12 d-flex button-grp-bottom">
                            <button className="btn btn-secondary w-50 mr-2" onClick={() => { this.props._sendToParent(false) }}>{COMMON.CANCEL}</button>
                            <button id="otp" type="button" className="btn btn-primary w-50" disabled={this.isFormValid()} onClick={this.handleGenerateOTP} >{COMMON.GENERATE_OTP}</button>

                            {/* This Must be hidden */}
                            <button id="otpButton" type="button" data-toggle="modal" data-target="#generateOtp"
                                className="d-none">placeholder</button>
                            <button id="otpFailed" type="button" data-toggle="modal" data-target="#regFailed"
                                className="d-none">placeholder</button>
                            <button id="otpSuccess" type="button" data-toggle="modal" data-target="#regSuccess"
                                className="d-none">placeholder</button>

                        </div>
                    </div>
                </form>

                {this.showOtpVerificationPopup()}
                {this.showOptVerifyFailedPopup()}
                {this.showOptVerifySuccessPopup()}


            </div>
        );
    }

    showOtpVerificationPopup = () => {
        const { digit1, digit2, digit3, digit4, time, seconds } = this.state;
        return (
            <div className="modal fade bottom-drawer" id="generateOtp" aria-modal="true" role="dialog">
                <div className="modal-dialog">
                    <div className="modal-content">
                        <div className="modal-body text-center">
                            <button type="button" className="close d-none d-md-block" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">×</span>
                            </button>
                            <h6 className="font-weight-medium  mt-4">We have sent you One Time Password to your number</h6>
                            <p className="red-color">Please Enter OTP</p>
                            <span>{time.s} sec</span>
                            <form action="">
                                <div className="form-group otp-input mt-md-3">
                                    <input type="number" className="form-control" placeholder="-" name="digit1" maxLength="1" ref={(ip) => this.myInp1 = ip} value={digit1} onChange={(e) => { this.handleOTPChange(e, this.myInp2) }} />
                                    <input type="number" className="form-control" placeholder="-" name="digit2" maxLength="1" ref={(ip) => this.myInp2 = ip} value={digit2} onChange={(e) => { this.handleOTPChange(e, this.myInp3) }} />
                                    <input type="number" className="form-control" placeholder="-" name="digit3" maxLength="1" ref={(ip) => this.myInp3 = ip} value={digit3} onChange={(e) => { this.handleOTPChange(e, this.myInp4) }} />
                                    <input type="number" className="form-control" placeholder="-" name="digit4" maxLength="1" ref={(ip) => this.myInp4 = ip} value={digit4} onChange={(e) => { this.handleOTPChange(e, this.myInp1) }} />
                                </div>
                                {/* <p className="info-paragraph">Enter mobile number / email address registered with us.</p> */}
                                <div className="d-flex justify-content-center">
                                    <button type="button"
                                        className="btn btn-secondary w-50 mr-2"
                                        data-dismiss="modal"
                                        onClick={this.handleResendOTP}
                                        disabled={seconds > 0}>{COMMON.RESEND_OTP}</button>
                                    <button id="continue" type="button"
                                        className="btn btn-primary w-50"
                                        onClick={this.verifyRetailerOtp}
                                        data-dismiss="modal">{COMMON.SUBMIT}</button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        )

    }

    showOptVerifyFailedPopup = () => {
        return (
            <div className="modal fade bottom-drawer show" id="regFailed" aria-modal="true" role="dialog">
                <div className="modal-dialog">
                    <div className="modal-content">
                        <div className="modal-body text-center">
                            <button type="button" className="close d-none d-md-block" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">×</span>
                            </button>
                            <img src="../assets/images/Wrong.png" alt="" />
                            <h3 className="font-weight-medium  mt-4">Registration Failed</h3>
                            <p>There was an error. Please enter correct OTP</p>
                            <button type="button"
                                className="btn btn-primary w-50 mb-2"
                                data-dismiss="modal"
                                onClick={this.handleResendOTP}>{COMMON.RESEND_OTP}</button>
                        </div>
                    </div>
                </div>
            </div>
        )
    }

    showOptVerifySuccessPopup = () => {
        return (
            <div className="modal fade bottom-drawer show" id="regSuccess" aria-modal="true" role="dialog">
                <div className="modal-dialog">
                    <div className="modal-content">
                        <div className="modal-body text-center py-4">
                            <button type="button" className="close d-none d-md-block" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">×</span>
                            </button>
                            <img src="../assets/images/Right.png" alt="" />
                            <h3 className="font-weight-medium  mt-4">Registration Success!</h3>
                            <p>Thank you for Retailer Registration.</p>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default withRouter(RetailerRegistrationPage);